import { defineMessages } from 'react-intl';

import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';

export const reportCardTitle = defineMessages<ReportType>({
  [ReportType.ReportType_InvalidValue]: {
    id: 'reportCard.ReportType.ReportType_InvalidValue',
    defaultMessage: 'Unknown report',
  },
  // Radiological
  [ReportType.ReportType_CBCT_GP]: {
    id: 'reportCard.ReportType.ReportType_CBCT_GP',
    defaultMessage: 'CBCT AI',
  },
  [ReportType.ReportType_CBCT_Segmentation]: {
    id: 'reportCard.ReportType.ReportType_CBCT_Segmentation',
    defaultMessage: '3D Model AI',
  },
  [ReportType.ReportType_CBCT_OrthoSlides]: {
    id: 'reportCard.ReportType.ReportType_CBCT_OrthoSlides',
    defaultMessage: 'Ortho AI',
  },
  [ReportType.ReportType_CBCT_Implant]: {
    id: 'reportCard.ReportType.ReportType_CBCT_Implant',
    defaultMessage: 'Implantology Study',
  },
  [ReportType.ReportType_CBCT_Endo]: {
    id: 'reportCard.ReportType.ReportType_CBCT_Endo',
    defaultMessage: 'Endodontic Study',
  },
  [ReportType.ReportType_CBCT_Molar]: {
    id: 'reportCard.ReportType.ReportType_CBCT_Molar',
    defaultMessage: 'Third Molar Study',
  },
  [ReportType.ReportType_Pano_GP]: {
    id: 'reportCard.ReportType.ReportType_Pano_GP',
    defaultMessage: 'Pano AI',
  },
  // FMX
  [ReportType.ReportType_IOXRay_GP]: {
    id: 'reportCard.ReportType.ReportType_IOXRay_GP',
    defaultMessage: 'IOXRay AI',
  },
  [ReportType.ReportType_DentalPhoto_GP]: {
    id: 'reportCard.ReportType.ReportType_DentalPhoto_GP',
    defaultMessage: 'ReportType_DentalPhoto_GP',
  },
  [ReportType.ReportType_IOS_Segmentation]: {
    id: 'reportCard.ReportType.ReportType_IOS_Segmentation',
    defaultMessage: 'IOS AI',
  },
  [ReportType.ReportType_CBCT_IOS_Superimposition]: {
    id: 'reportCard.ReportType.ReportType_CBCT_IOS_Superimposition',
    defaultMessage: '3D Model AI + Superimposition',
  },
  [ReportType.ReportType_StudioImplant]: {
    id: 'reportCard.ReportType.ReportType_ImplantStudio',
    defaultMessage: 'Implant AI',
  },
  [ReportType.ReportType_StudioOrtho]: {
    id: 'reportCard.ReportType.ReportType_OrthoStudio',
    defaultMessage: 'Ortho AI',
  },
  [ReportType.ReportType_Pano_Bitewings]: {
    id: 'reportCard.ReportType.ReportType_Pano_Bitewings',
    defaultMessage: 'Panowings AI',
  },
});
